import React, { useState, useEffect } from 'react';
import Modal from '../../../../../components/molecules/Modal';
import AsyncSelect from 'react-select/async';
import { getAddresses } from '../../../../../store/action/address';
import { fulfillOrder } from '../../../../../store/action/order';
 
export default function (props) {
    const [ addressId, setAddressId ] = useState("");
    const [ selectedAddress, setSelectedAddress ] = useState([]);
    const [ loading, setLoading ] = useState({
        loading:false
    });

    const submitFulfillment = async () => {
        setLoading({...loading,loading:true});
        const fulfillmentServiceCode = 'gudangio';
        let failed = 0;
        let success = 0;
        if (props.data.length > 0) {
            for (let i = 0; i < props.data.length;i++) {
                const response = await fulfillOrder(props.data[i].orderId,fulfillmentServiceCode,addressId);
                if (response.success) {
                    setLoading({...loading,loading:true})
                    success = success+1;
                } else {
                    setLoading({...loading,loading:true})
                    failed = failed+1;
                }
            }
            alert(`${success} orders success and ${failed} orders failed from total ${props.data.length} `);
            window.location.reload();
            return 
        } else {
            const response = await fulfillOrder(props.orderId,fulfillmentServiceCode,addressId);
            if (response.success) {
                alert(response.message);
                window.location.reload();
                return 
            } else {
                alert(response.error);
                setLoading({...loading,loading:false});
                return 
            }
        }
    }

    const onChangeAddress = (e) => {
        const addressId = e.value;
        setSelectedAddress(e);
        setAddressId(addressId)
    }

    const getAddressData = async () => {
        const result = await getAddresses();
        if (!result.success) return;
        const formattedResult = result.addresses.reduce((r,i) => {
            r.push({label:i.name,value:i.id}); return r;
        },[]);
        return formattedResult
    }

    const promiseOptions = inputValue =>
        new Promise(resolve => {
            setTimeout(() => {
                resolve(getAddressData(inputValue));
            }, 1000);
    });
    

    return (
        <Modal
            buttons={true}
            show={props.show}
            loading={loading.loading}
            onHide={props.onHide}
            title={"Buat Fulfillment Order"}
            bodyClassName="p-0"
            size={"md"}
            bText={"Buat Fulfillment"}
            bClick={() => submitFulfillment()}
            type={"oneButton"}
        >
            <div className="p-4">
                <h6>
                    Pilih Lokasi Asal
                </h6>    
                <AsyncSelect
                    cacheOptions
                    value={selectedAddress}
                    onChange={e => onChangeAddress(e)}
                    loadOptions={promiseOptions}
                    defaultOptions
                    placeholder="Pilih Alamat Asal Pengiriman"
                />
             
            </div>
        </Modal>
    )
}